export const PICTOGRAM_TYPES = Object.freeze({
  MECHANICAL: 'mechanical_installation',
  ELECTRICAL: 'electrical_installation',
  DITCHES:    'electrical_trenches',
  BURIED_EVACUATION: 'buried_evacuation_line',
  AERIAL_EVACUATION: 'aerial_evacuation_line',
})

export const PICTOGRAM_TYPES_LIST = Object.values(PICTOGRAM_TYPES)
